import React, { useState, useEffect } from 'react';
import moment from 'moment';
import 'moment-timezone';
import $ from "jquery";
import { Table } from "antd";
import LZString from 'lz-string';
import logo from './../../assets/img/favicon-dark.png';

function UptimeReport() {

    const getPathParams = () => {
        var pathParams = window.location.search;
        pathParams = pathParams.length > 0 ? pathParams.substring(1) : '';
        return pathParams.length > 0 ? JSON.parse(LZString.decompressFromBase64(pathParams)) : {};
    };
    const [user, setUser] = useState(getPathParams());
    const [loading, setLoading] = useState(true);
    const [device_category, setDeviceCategory] = useState([]);
    const [location_alerts, setLocationAlerts] = useState([]);
    const [site_level, setSiteLevel] = useState([]);
    const [devices, setDevices] = useState([]);
    const [disconnected_gt, setDisconnectedGt] = useState([]);
    const [overallUptime, setOverallUptime] = useState('');

    const report_columns = [
        {
            title: "Serial No",
            dataIndex: 'serial_no',
            render: (serial_no, record) => {
                let device_assetsn = devices && devices.find((d) => d.location_id === record.location_id) && devices.find((d) => d.location_id === record.location_id).device_assetsn;
                return <span>{device_assetsn === undefined ? (record.device_id === "0" ? record.location_id : record.device_id) : device_assetsn}</span>
            }
        },
        {
            title: "Zone Name",
            dataIndex: 'location_name',
            render: (location_name, record) => {
                return <span>{record.location_name}</span>
            }
        },
        {
            title: "Type",
            dataIndex: 'location_device_type',
            render: (location_device_type, record) => {
                let deviceCategory = device_category && device_category.find((r) => record.device_id === r.device_id) && device_category.find((r) => record.device_id === r.device_id).device_category;
                return <span>{record.location_device_type === "axis" ? (deviceCategory === "Z" ? "Bullet" : (deviceCategory === "PTZ" ? "PTZ" : "No data")) : "Gateway"}</span>
            }
        },
        {
            title: "Power",
            dataIndex: 'solar_pod_info',
            render: (solar_pod_info, record) => {
                return <span>{record.solar_pod_info && record.solar_pod_info.trim().length > 0 ? "Solar" : "Cable"}</span>
            }
        },
        {
            title: "Uptime",
            dataIndex: 'up_time',
            render: (up_time, record) => {
                let location_gt_level = site_level.filter((l) => l.location_id === record.location_id);
                let upPercentage = 0;
                if (record.location_unplugged) {
                    return <span>NA</span>
                }
                if (location_gt_level.length === 0) {
                    let dis_gateway = disconnected_gt && disconnected_gt.find((d) => d.device_id === record.device_id) && disconnected_gt.find((d) => d.device_id === record.device_id).up_timestamp;
                    if (dis_gateway === null) {
                        upPercentage = 0;
                    } else if (record.device_id === "0") {
                        upPercentage = 0;
                    } else {
                        upPercentage = 100;
                    }
                } else {
                    let down_time = 0;
                    for (let i of location_gt_level) {
                        if (i.up_timestamp === null) {
                            continue
                        }
                        if (i.up_timestamp > user.end_date_ts) {
                            i.up_timestamp = user.end_date_ts
                        }
                        down_time += (i.up_timestamp - i.down_timestamp);
                    }
                    if (down_time === 0) {
                        upPercentage = 0
                    } else {
                        let total_time = user.end_date_ts - user.start_date_ts;
                        let up_time = total_time - down_time;
                        upPercentage = ((up_time / total_time) * 100);
                    }
                }

                return <span>{upPercentage.toFixed(2)} %</span>
            }
        },
        {
            title: "Alerts",
            dataIndex: 'location_id',
            render: (location_id) => {
                let count = 0;
                for (const key in location_alerts) {
                    console.log(key)
                    count = location_alerts[location_id] ? location_alerts[location_id].length : 0
                }
                return <span>{count}</span>
            }
        }
    ];

    useEffect(() => {
        document.body.style.backgroundColor = '#fff';
        setUser(user);
        customerGatewayStats();
    }, [user]);

    useEffect(() => {
        if (site_level !== null) {
            fetchDevices();
            disconnectedGatewayStats();
            fetchNotifications();
        }
    }, [site_level]);

    useEffect(() => {
        if (disconnected_gt !== null) {
            fetchOverallUptime();
        }
    }, [disconnected_gt]);

    const getDeviceCategory = async () => {
        var promises = [];
        for (var zone of user.zones) {
            if (zone.device_id && zone.location_device_type === 'axis') {
                promises.push(await controlCamera(zone.device_id));
            }
        }
        setDeviceCategory(promises);
        setLoading(false);

    }

    const controlCamera = (device_id) => {
        return new Promise(function (resolve, reject) {
            $.ajax(
                {
                    url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/axis-camera/info',
                    type: 'POST',
                    contentType: "application/json; charset=utf-8",
                    dataType: "json",
                    headers: {
                        user_login: user.user_login,
                        user_token: user.user_token
                    },
                    data: JSON.stringify({ device_id }),
                }
            ).then((res) => {
                if (res && res.status && res.status.code === 200) {
                    resolve({ device_id: device_id, device_category: res.data.device_category });
                } else {
                    resolve({});
                }
            }, (res) => {
                resolve({});
            })
        })
    }

    const fetchNotifications = () => {
        let data = {
            user_login: user.user_login,
            user_token: user.user_token,
            site_id: user.site_selected.site_id,
            form_input: {
                "query": JSON.stringify({
                    attributes: ["*"],
                    object: 'event_history',
                    filters: [
                        { attribute: 'dev_timestamp', value: user.end_date_ts, operator: '<=' },
                        { join_by: 'and', attribute: 'dev_timestamp', value: user.start_date_ts, operator: '>=' }
                    ],
                    sort_by: [{ attribute: 'dev_timestamp', value: 'asc' }],
                    pagination: { page: 1, size: 1000 }
                })
            }
        }

        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/data-explorer',
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res && res.status && res.status.code === 200) {
                    let location_alerts = {};
                    for (const loc of res.data) {
                        if (!location_alerts[loc.location_id]) {
                            location_alerts[loc.location_id] = [loc]
                        } else {
                            location_alerts[loc.location_id].push(loc);
                        }

                    }
                    setLocationAlerts(location_alerts);
                    getDeviceCategory();
                } else {
                    setLocationAlerts({});
                    getDeviceCategory();
                }

            })
    }

    const customerGatewayStats = () => {
        let data = {
            customer_id: user.site_selected.customer_id,
            start_ts: user.start_date_ts,
            end_ts: user.end_date_ts,
            user_login: user.user_login,
            user_token: user.user_token
        }

        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod//admin/device/customer-gateway-stats',
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then((result) => {
            let results = result.data;
            let site_level = results.filter((s) => s.site_id === user.site_selected.site_id);
            setSiteLevel(site_level);
        });
    }

    const disconnectedGatewayStats = () => {
        let data = {
            site_id: user.site_selected.site_id,
            start_ts: user.start_date_ts,
            user_login: user.user_login,
            user_token: user.user_token
        }

        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod//admin/device/disconnected-by-date',
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then((result) => {
            let results = result.data;
            setDisconnectedGt(results);
            fetchOverallUptime();
        });
    }

    const fetchOverallUptime = () => {
        let arr = [];
        let upPercentage = 0;
        for (let zone of user.zones) {
            let location_gt_level = site_level.filter((l) => l.location_id === zone.location_id);
            if (zone.location_unplugged) {
                continue;
            }
            if (location_gt_level.length === 0) {
                let dis_gateway = disconnected_gt && disconnected_gt.find((d) => d.device_id === zone.device_id) && disconnected_gt.find((d) => d.device_id === zone.device_id).up_timestamp;
                if (dis_gateway === null) {
                    upPercentage = 0;
                } else if (zone.device_id === "0") {
                    upPercentage = 0;
                } else {
                    upPercentage = 100;
                }
            } else {
                let down_time = 0;
                for (let i of location_gt_level) {
                    if (i.up_timestamp === null) {
                        continue
                    }
                    if (i.up_timestamp > user.end_date_ts) {
                        i.up_timestamp = user.end_date_ts
                    }
                    down_time += (i.up_timestamp - i.down_timestamp);
                }
                if (down_time === 0) {
                    upPercentage = 0
                } else {
                    let total_time = user.end_date_ts - user.start_date_ts;
                    let up_time = total_time - down_time;
                    upPercentage = ((up_time / total_time) * 100);
                }
            }

            arr.push(upPercentage)
        }
        let sum_uptime = arr.reduce((accumulator, currentValue) => accumulator + currentValue, 0);

        let total_length = arr.length * 100;
        let overallUptime = (sum_uptime / total_length) * 100;
        setOverallUptime(overallUptime);
    }

    const fetchDevices = () => {
        let data = {
            user_login: user.user_login,
            user_token: user.user_token,
            form_input: {
                query: JSON.stringify({
                    attributes: ['site_id', 'location_id', 'device_id', 'device_assetsn'],
                    object: 'device',
                    filters: [{ attribute: 'site_id', value: user.site_selected.site_id, operator: '=' }],
                    sort_by: [{ attribute: 'location_id', value: 'asc' }],
                    pagination: { page: 1, size: 1000 }
                }),
            }
        }

        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/data-explorer',
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res && res.status && res.status.code === 200) {
                    setDevices(res.data);
                } else {
                    setDevices([]);
                }
            });
    }

    const setPDFContentReady = () => {
        window.status = 'ready';
    }

    return (
        <React.Fragment>
            <div className="container">
                <div className="row">
                    <div className="col-md-12 my-5">
                        <span className="navbar-brand text-primary">
                            <img src={logo} alt="logo" style={{ width: "25px", marginRight: '10px' }} />
                            {"SiteSupt OnDemand"}
                        </span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12  p-1 mb-2">
                        <h4>Uptime Report</h4>
                    </div>
                    <div className="col-md-12">
                        <h5 className="text-app">{user && user.site_selected && user.site_selected.site_name}</h5> <br />
                        <b>Start Date</b>: {moment.unix(user.start_date_ts).format("DD/MM/YYYY")} <br />
                        <b>End Date</b>: {moment.unix(user.end_date_ts).format("DD/MM/YYYY")}
                    </div>
                </div>
                {!loading && <div className="row">
                    <div className="col-md-12 pt-1">
                        <span className="font-size-5">
                            <b>Overall Uptime:</b>&nbsp;<span>{String(overallUptime && overallUptime.toFixed(2))} %</span>
                        </span>
                    </div>
                </div>}
                <div className="row bg-white">
                    <div className="col-md-12 p-1">
                        <Table
                            loading={loading}
                            rowKey="location_id"
                            dataSource={loading ? [] : user.zones}
                            columns={report_columns}
                            pagination={false}
                        />
                    </div>
                </div>
                {!loading && setPDFContentReady()}
            </div>
        </React.Fragment>
    );
}

export default UptimeReport;